module.exports = __webpack_public_path__ + "static/media/sun-dust.e778267b.svg";